let isRefreshing = false
let subscribers = []

function subscribeTokenRefresh(cb) {
  subscribers.push(cb)
}

function onRefreshed() {
  subscribers.map((cb) => cb())
}

export function setupAxiosInterceptors(axios, store) {
  /**
   * Axios request interceptor
   */
  axios.interceptors.request.use(async (config) => {
    const jwtToken = await store.getters['staff/getAccessToken']
    if (jwtToken != null) {
      config.headers.Authorization = 'Bearer ' + jwtToken
    }

    return config
  })

  /**
   * Axios response interceptors
   */
  axios.interceptors.response.use(
    (response) => {
      return response
    },
    async (err) => {
      const {
        config,
        response: { status, data },
      } = err

      const originalRequest = config

      if (status === 401 && data.code == 1401) {
        console.log(data)
        if (!isRefreshing) {
          isRefreshing = true
          await store
            .dispatch('staff/refreshToken')
            .then(({ status }) => {
              if (status === 200 || status == 204) {
                isRefreshing = false
              }
              subscribers = []
            })
            .catch(() => {
              console.error('Refresh Token Expired')
              store.dispatch('staff/destroyAuth')
              subscribers = []
            })
        }

        const requestSubscribers = new Promise((resolve) => {
          subscribeTokenRefresh(() => {
            resolve(axios(originalRequest))
          })
        })

        onRefreshed()

        return requestSubscribers
      }
      return Promise.reject(err)
    }
  )

  subscribers = []
}
